// Quill and our blots, loaded the first time an editor needs them so they stay out of the
// bundle every page downloads (webpack puts this import() in its own file).
let quillModule
let loadedModule = null

export function loadQuill () {
  quillModule ||= Promise.all([import("quill"), import("./blots")]).then(([{ default: Quill }, blots]) => {
    blots.registerQuillBlots()
    loadedModule = { Quill, Delta: Quill.import("delta"), blots }
    return loadedModule
  })
  return quillModule
}

// The module once loadQuill() has resolved (an editor on the page means it has), else null.
export function loadedQuill () {
  return loadedModule
}
